<div class="body">
  <div class="container">
    <button mat-raised-button color="accent" class="big-round-shape-button" (click)="connectAccount()"> Get Account</button>

    <div style="text-align:center">
      <section class="header">
        <img [src]="data" class="profile" />
        <h4>Your address is:</h4>
        <h6>{{ res }} </h6>
        <h4>Balance:</h4>
        <h5>{{balance}} ETH</h5>
      </section>
    </div>

  </div>
</div>

